var scope_0 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/88f905d203972ccd4947dbe4ec1409ae.js').default;export default
        Object.assign({}, scope_0 )
    